import Link from 'next/link';
import { useTranslations } from 'next-intl';
import React from 'react';

import { stringFormatJsx } from '../helpers/string-helper';

type CookieConsentDescriptionProps = {
    // Where the privacy policy lives. Apps served under customer domains — the movie landing pages
    // and the cinema website — have no `/data-protection` route of their own, so the default would
    // link the visitor into a 404 from inside the consent banner (CIN-14630).
    privacyPolicyUrl: string;
};

/**
 * The consent intro shared by the cookie banner and the preferences dialog — same copy, same link,
 * so it lives once.
 */
export function CookieConsentDescription({ privacyPolicyUrl }: CookieConsentDescriptionProps): React.JSX.Element {
    const t = useTranslations();

    // An absolute URL points at another site (the operator's own document, or Cineamo's web app for
    // a customer domain). It opens in a new tab so a visitor who has not answered the banner yet is
    // not navigated away from the page the pending decision belongs to.
    const opensExternally = privacyPolicyUrl.startsWith('http');

    return (
        <span className="text-body-12">
            {stringFormatJsx(
                t('common.cookies-modal.description', {
                    0: '{0}'
                }),
                <Link
                    className="underline"
                    href={privacyPolicyUrl}
                    target={opensExternally ? '_blank' : undefined}>
                    {t('common.cookies-modal.privacy-policy')}
                </Link>
            )}
        </span>
    );
}

export default CookieConsentDescription;
